export default {
  improvement_plans_detail: {
    create_form: {
      cautions_title: '@:settings.cautions_title',
      cautions_content: '・The information to be filled in the improvement plan is shown in {toCompanyName}.\n・Attachments are displayed in {toCompanyName}, and only the file name will be displayed.',
    },
    chat: {
      card_title: 'Message',
      input_area_description: 'You can send a message to {toCompanyName} regarding the improvement plan',
      send_confirm: {
        modal_title: 'Send a message',
        confirm_text: 'Are you sure you want to send this message?',
        confirm_text_near_by_check_box: 'Message checked',
        send_button_label: '@:upload_common.send',
      },
      send_complete: {
        toast_text: 'Message sent successfully',
      },
      delete_confirm: {
        modal_title: 'Delete this message',
        confirm_text: 'Are you sure you want to delete this message?',
        delete_button_label: '@:settings.button.do_delete',
      },
      log: {
        title: 'Send history',
        send_status: {
          success: 'Sent',
          failure: 'Failed to send',
        },
      },
    },
  },
}
